<template>
  <div class="p_onePass">
    <el-form
      v-loading="loading"
      :model="form"
      ref="myForm"
      :rules="rules"
      hide-required-asterisk
    >
      <el-form-item
        v-if="
          serviceType == 'HZMB_RENEW_PERSON' ||
          serviceType == 'HZMB_RENEW_COMPANY'
        "
        :label="$t('message.validate_type')"
        prop="type"
      >
        <el-select
          v-model="form.type"
          value-key="code"
          filterable
          @change="changeType"
        >
          <el-option
            v-for="item in type"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- sp編號 -->
      <el-form-item
        v-if="
          serviceType == 'HZMB_FIRST_PERSON' ||
          serviceType == 'HZMB_FIRST_COMPANY' ||
          (form.type == 'spNo' && serviceType != 'TAXI_ANNUAL')
        "
        :label="$t('message.spNo')"
        prop="spNo"
      >
        <el-input
          v-model="form.spNo"
          :placeholder="$t('message.spNo_placeholder')"
          @keyup.enter.native="submit"
        ></el-input>
      </el-form-item>
      <!-- 的士駕駛員證編號 -->
      <el-form-item
        v-if="serviceType == 'TAXI_ANNUAL'"
        :label="$t('message.taxiCertNo')"
        prop="taxiCertNo"
      >
        <el-input
          v-model="form.taxiCertNo"
          :placeholder="$t('message.taxiCertNo_plh')"
        ></el-input>
      </el-form-item>
      <!-- 澳門駕駛執照編號 -->
      <el-form-item
        v-if="['DRV_LIC_INTER'].includes(serviceType)"
        :label="$t('message.macau_driver_no')"
        prop="licenseNo"
      >
        <el-input
          v-model="form.licenseNo"
          :placeholder="$t('message.macau_driver_no_plh')"
        ></el-input>
      </el-form-item>
      <!-- 身份證明文件類別 -->
      <el-form-item
        v-if="serviceType == 'DRV_LIC_INTER'"
        :label="$t('message.idType')"
        prop="identType"
      >
        <el-select
          v-model="form.identType"
          value-key="code"
          filterable disabled
        >
          <el-option
            v-for="item in idType"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 車輛的註冊編號 -->
      <el-form-item
        v-if="form.type == 'registrationNo'"
        :label="$t('message.DataRegistration.Vehicle.registNoAndIdNo')"
        prop="regAndIdNo"
      >
        <el-input
          :placeholder="
            $t('message.DataRegistration.Vehicle.registNoAndIdNo_plh')
          "
          ref="registrationNo"
          v-model="form.regAndIdNo"
          class="input-with-select"
          @focus="onRegistNoFocus"
        ></el-input>
      </el-form-item>
      <!-- 澳門居民身份證編號 -->
      <el-form-item
        :label="serviceType == 'DRV_LIC_INTER' ? $t('message.idNo') : $t('message.Verification.personal.id_no')"
        prop="identityNo"
      >
        <el-input v-model="form.identityNo" disabled></el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <el-form-item :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model.number="form.mobile"
          :placeholder="$t('message.Verification.mobile_placeholder')"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn @click="submit" :loading="loading">{{
          $t("message.account_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
    <!-- 註冊編號和車身編號彈窗 -->
    <RegistrationNoDialog
      v-if="showRegistrationNoDialog"
      @save="registNoSave"
      @close="showRegistrationNoDialog = false"
    ></RegistrationNoDialog>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import GradientBtn from "../../../components/GradientBtn";
import ApplicationAPI from "../../../api/ApplicationAPI";
import LoginAPI from "../../../api/LoginAPI";
import TaxiApplicationAPI from "../../../api/TaxiApplicationAPI";
import DrivIntApplicationAPI from "../../../api/DrivIntApplicationAPI";
import HzmbApplicationAPI from "../../../api/HzmbApplicationAPI";
import RegistrationNoDialog from "../../../components/RegistrationNoDialog";
import safpBridgeObj from "../../../plugins/govmo-js-sdk";
import { basePath } from "../../../api/axios";
import HeadmasterRenewApplicationAPI from '@/api/HeadmasterRenewApplicationAPI';
import CoachRenewApplicationAPI from '@/api/CoachRenewApplicationAPI';
export default {
  components: { GradientBtn, RegistrationNoDialog },
  data() {
    let taxiCertNoCheck = (rule, value, callback) => {
      // 驗證的士駕駛證
      let reg = /^([^0]|.{2,})$/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.taxiCertNo")));
      } else {
        callback();
      }
    };
    let identityNoCheck = (rule, value, callback) => {
      // 驗證澳門居民身份證編號
      let reg = /[0-9]{8}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.identityNo")));
      } else {
        callback();
      }
    };
    return {
      // form: {},
      basePath: basePath,
      loading: false,
      rules: {
        type: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        taxiCertNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          {
            max: 6,
            message: i18n.t("message.formRuleMessage.maxLength6"),
            trigger: "blur",
          },
          { validator: taxiCertNoCheck, trigger: "blur" },
        ],
        spNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          { max: 10, message: i18n.t("message.formRuleMessage.maxLength10") },
        ],
        regAndIdNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        identityNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
      },
      showRegistrationNoDialog: false,
      type: [
        { code: "spNo", label: "message.spNo" },
        {
          code: "registrationNo",
          label: "message.DataRegistration.Vehicle.registrationNo",
        },
      ],
      idType: [
        { code: "BM", label: "message.idType_macau" },
        {
          code: "OTHER",
          label: "message.idType_other",
        },
      ],
      licenseNo: [
        // {
        //   required: true,
        //   message: i18n.t("message.formRuleMessage.notNull"),
        //   trigger: "blur",
        // },
        {
          max: 20,
          message: i18n.t("message.formRuleMessage.maxLength20"),
          trigger: "blur",
        },
      ],
      
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceType() {
      return this.$store.state.serviceType;
    },
  },
  methods: {
    submit() {
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          localStorage.setItem("verifyForm", JSON.stringify(this.form));
          if (this.serviceType == "TAXI_ANNUAL") {
            this.taxiCheck();
          }else if(this.serviceType == 'DRV_LIC_INTER') {
            this.internationCheck();
          } else {
            this.getVss();
          }
        }
      });
    },

    // 驗證車身註冊編號
    onRegistNoFocus() {
      this.$refs["registrationNo"].blur();
      this.showRegistrationNoDialog = true;
    },
    // 關閉註冊編號彈窗
    handleClose() {
      this.showRegistrationNoDialog = false;
    },
    // 註冊編號儲存
    registNoSave(data) {
      // console.log(data);
      // this.form.registrationNo = data.registrationNo;
      // this.form.identificationNo = data.identificationNo;

      const registrationNo = data.registrationNo;
      const identificationNo = data.identificationNo;
      // console.log(new Array(registrationNo.replace(/(.{2})/g, "$1,")));

      // 為字符串每個length個字，添加一條橫線
      // const xreplace = (str, length) => {
      //   if (str.indexOf("-") != -1) {
      //     return str;
      //   }
      //   // str = str.replace(/-/g, "");
      //   var re = new RegExp("[a-zA-Z]{1,2}|[0-9]{1," + length + "}", "g");
      //   var ma = str.match(re);
      //   // console.log("\\d{1," + length + "}");
      //   return ma.join("-");
      // };

      this.$set(this.form, "regAndIdNo", registrationNo);
      this.$set(this.form, "registrationNo", registrationNo);
      this.$set(this.form, "identificationNo", identificationNo);
      this.showRegistrationNoDialog = false;
    },
    // 獲取vss數據
    getVss() {
      const serviceType = this.$store.state.serviceType;
      const verifyForm = this.form;
      let identType = "BM";
      let identNo = verifyForm.identityNo;
      const spNo = verifyForm.spNo || null;
      const registrationNo = verifyForm.registrationNo || null;
      const identificationNo = verifyForm.identificationNo || null;
      if(serviceType != 'HZMB_FIRST_PERSON' && serviceType != 'HZMB_RENEW_PERSON'){
        this.$message({
          type: 'error',
          message: this.$t('message.different_login_type')
        });
        this.$notify({
          type:'error',
          showClose: false,
          title: this.$t('message.tips'),
          message: this.$t('message.backToHome'),
          position: 'bottom-right',
          duration: 4500
        });
        setTimeout(() => {
          const page =  localStorage.getItem('childTempTitle') || 'one';
          if(page == 'three'){
            this.$router.push('/entryTaxi');
          }else if(page == 'two'){
            this.$router.push('/entryBus');
          }else{
            this.$router.push('/entry');
          }
        }, 5000);
        return;
      }
      this.loading = true;
      HzmbApplicationAPI.getVss(
        serviceType,
        identType,
        identNo,
        spNo,
        registrationNo,
        identificationNo
      )
        .then((res) => {
          // console.log(res);
          this.loading = false;
          if (res.success) {
            // 清除form
            // const verifyForm = localStorage.getItem("verifyForm")
            //   ? JSON.parse(localStorage.getItem("verifyForm"))
            //   : null;
            // if (verifyForm && verifyForm.spNo != this.form.spNo) {
            localStorage.setItem("form", "");
            this.$store.commit("changeDocumentType", []);
            // }

            this.$router.replace("/formData");
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: res.errorMsgs
                .map((item) => {
                  return item.textCn;
                })
                .join("/n"),
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    changeType() {
      delete this.form.spNo;
      delete this.form.registrationNo;
      delete this.form.regAndIdNo;
      // this.$set(this.form, "spNo", null);
      // this.$set(this.form, "registrationNo", null);
      // this.$set(this.form, "regAndIdNo", null);
    },
    // 驗證的士服務准入條件
    taxiCheck() {
      const serviceType = this.$store.state.serviceType;
      const verifyForm = this.form;
      let identType = "BM";
      let identNo = verifyForm.identityNo;
      const taxiCertNo = verifyForm.taxiCertNo;
      this.loading = true;
      TaxiApplicationAPI.check(serviceType, identType, identNo, taxiCertNo)
        .then((res) => {
          this.loading = false;
          if (
            res &&
            res.application &&
            (res.application.spCode == "D02" || res.application.spCode == 'D01' || res.application.spCode == "D11" || res.application.spCode == "T01" || res.application.spCode == "T06")
          ) {
            this.$message({
              type: "error",
              message: res.application.spResultCn,
            });
          } else {
            localStorage.setItem("form", "");
            this.$store.commit("changeDocumentType", []);
            localStorage.setItem("taxiApplication", JSON.stringify(res));
            this.$store.commit("changeTaxiApplication", res);
            this.$router.push("/taxi");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 驗證的士服務准入條件
    internationCheck() {
      const serviceType = this.$store.state.serviceType;
      const verifyForm = this.form;
      let identType = verifyForm.identType;
      let identNo = verifyForm.identityNo;
      const licenseNo = verifyForm.licenseNo || null;
      const spNo = this.form.spNo;
      this.loading = true;
      DrivIntApplicationAPI.check(serviceType, identType, identNo, licenseNo, spNo)
        .then((res) => {
          this.loading = false;
          const errSpCode = ['D01','D02','D11','D21','D23','D41','D99','T01','T06'];
          if (res && res.application && errSpCode.includes(res.application.spCode)) {
            this.$message({
              type: "error",
              message: res.application.spResultCn,
            });
          } else {
            localStorage.setItem("form", "");
            this.$store.commit("changeDocumentType", []);
            localStorage.setItem("drivApplication", JSON.stringify(res));
            this.$store.commit("changeDrivApplication", res);
            this.$router.push("/international");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 一戶通登入
    accountLogin(code, token) {
      const serviceType = this.$store.state.serviceType;
      this.loading = true;
      LoginAPI.account(code, token, serviceType)
        .then((res) => {
          this.loading = false;
          // 非澳門電話彈窗
          if(res.data.mobile.indexOf('+') != -1){
            this.$alert(this.$t('message.must_macauMobile_login'), this.$t('message.tips'), {
              confirmButtonText: this.$t('message.confirm'),
              callback:() => {
                this.$router.replace('/personal');
                return false;
              }
            });
          }
          localStorage.setItem("accountData", JSON.stringify(res.data));
          localStorage.setItem("accountCode", code);
          localStorage.setItem("authentication", res.headers.authentication);
          this.$set(this.form, "identityNo", res.data.identityNo);
          this.$set(this.form, "identNo", res.data.identityNo);
          this.$set(this.form, "mobile", res.data.mobile);
        })
        .catch((err) => {
          this.loading = false;
          if (err.message.indexOf("401") != -1) {
            // this.$message({
            //   type: "error",
            //   message: this.$t("message.accountLoginFailed"),
            // });
            if (this.$store.state.isApp) {
              safpBridgeObj.getToken({
                success(res) {
                  console.log(res);
                  if (res && res.authToken) {
                    this.accountLogin(null, res.authToken, serviceType);
                  }
                },
                fail(res) {
                  console.log(res);
                  this.$message({
                    type: "error",
                    message: this.$t("message.accountLoginFailed"),
                  });
                },
              });
            } else {
              this.$router.replace("/personal");
            }
          } else {
            this.$error(err);
            this.$router.replace("/personal");
          }
        });
    },

  },
  created() {
 
    const code = this.$route.query.code || null;
    const token =
      sessionStorage.getItem("accountToken") || this.$route.query.token || null;
    const serviceType = this.$store.state.serviceType;
    const accountCode = localStorage.getItem("accountCode") || null;
    const accountData = JSON.parse(localStorage.getItem("accountData")) || null;
    if ((token || (code && accountCode != code)) && serviceType) {
      this.accountLogin(code, token);
    } else {
      if (!accountData) {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
      }
      // this.$router.push("/personal");
    }
  },
};
</script>

<style lang="scss" scoped>
.company {
}
</style>